import { genComponentStyleHook } from '../../theme/internal';
import { resetComponent } from '../../style';
import { getWebkitScrollbarStyle } from '../../style/scrollbar';
const getScrollbarVisibility = (visibility) => ({
    '&::-webkit-scrollbar-track': {
        visibility,
    },
    '&::-webkit-scrollbar-thumb': {
        visibility,
    },
    '&::-webkit-scrollbar-corner': {
        visibility,
    },
});
const genScrollbarStyle = (token) => {
    const { componentCls } = token;
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign({}, resetComponent(token)), getWebkitScrollbarStyle(token)), { '&-rtl': {
                direction: 'rtl',
            } }),
        [`${componentCls}-x-scroll`]: {
            overflowX: 'auto',
        },
        [`${componentCls}-y-scroll`]: {
            overflowY: 'auto',
        },
        [`${componentCls}-trigger-hover`]: Object.assign(Object.assign({}, getScrollbarVisibility('hidden')), { '&:hover': Object.assign({}, getScrollbarVisibility('visible')) }),
    };
};
// ============================== Export ==============================
export default genComponentStyleHook('Scrollbar', (token) => [
    genScrollbarStyle(token),
]);
